import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Addfeature = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = (e) => {
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setError(false);
      setFile({
        files: e.target.files[0],
        preview: URL.createObjectURL(e.target.files[0]),
      });
    } else {
      setError(true);
    }
  };

  const onSubmit = async (data) => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("media", file?.files);
    try {
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_API + "admin/feature/create",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/features");
      }
    } catch (error) {
      setLoading(false);
      if (error.response !== "" && error.response.data.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Add New Feature</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={
                  file
                    ? file.preview
                    : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>Feature Name</label>
                <input
                  type="text"
                  name="feature_name"
                  {...register("feature_name", {
                    required: "Feature name is required",
                    pattern: {
                      value: /^[a-zA-Z._ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Feature Name"
                />
                {errors.feature_name && (
                  <div className="invalid-feedback">
                    {errors.feature_name.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Feature Title</label>
                <input
                  type="text"
                  name="feature_title"
                  {...register("feature_title", {
                    required: "Feature title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Title Name"
                />
                {errors.feature_title && (
                  <div className="invalid-feedback">
                    {errors.feature_title.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  name="feature_description"
                  className="description-textarea"
                  {...register("feature_description", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.feature_description && (
                  <div className="invalid-feedback text-left">
                    {errors.feature_description.message}
                  </div>
                )}
              </div>

              <div className="formInput"></div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addfeature;
